var helpers = {};

helpers.formatNumber = function (sanitizedValue) {
  let formatted = "";
  for (let i = 0; i < sanitizedValue.length; i++) {
    if (i === 2 || i === 5 || i === 8) {
      formatted += `-${sanitizedValue[i]}`;
    } else {
      formatted += sanitizedValue[i];
    }
  }
  return formatted;
};

// example: (123)-123-1234
helpers.formatUSPhoneNumber = function (phone) {
  // Remove +1 if present at the start
  const sanitized = phone.replace(/^\+1/, "").replace(/\D/g, "");

  // Format as (123)-123-1234
  if (sanitized.length === 10) {
    return `(${sanitized.slice(0, 3)})-${sanitized.slice(
      3,
      6
    )}-${sanitized.slice(6)}`;
  }

  return phone; // Return original if not 10 digits
};

helpers.formatTaxId = function (sanitizedValue) {
  let formatted = "";
  for (let i = 0; i < sanitizedValue.length; i++) {
    if (i === 2) {
      formatted += `-${sanitizedValue[i]}`;
    } else {
      formatted += sanitizedValue[i];
    }
  }
  return formatted;
};

helpers.formatSSN = function (sanitizedValue) {
  let formatted = "";
  for (let i = 0; i < sanitizedValue.length; i++) {
    if (i === 3 || i === 5) {
      formatted += `-${sanitizedValue[i]}`;
    } else {
      formatted += sanitizedValue[i];
    }
  }
  return formatted;
};

// helpers.extractAddressComponents = function (addressString) {
//     if (!addressString || typeof addressString !== 'string') {
//         return false;
//     }
    
//     const parts = addressString.split(",").map(p => p.trim());
  
//     // Return false if not enough parts to extract city, state+zip, and country
//     if (parts.length < 3) return false;

//     // Extract country from the last part
//     const country = parts[parts.length - 1];
  
//     // Extract zip and state from second last part with more flexible regex
//     const stateZipMatch = parts[parts.length - 2].match(/^\s*([A-Z]{2})\s+(\d{5}(?:-\d{4})?)\s*$/i);
//     if (!stateZipMatch) return false;
  
//     const state = stateZipMatch[1].toUpperCase();
//     const zipCode = stateZipMatch[2];
  
//     // City is before state+zip
//     const city = parts[parts.length - 3];
  
//     // Handle street parsing
//     const streetParts = parts.slice(0, parts.length - 3);
//     let houseNumber = "";
//     let streetName = "";
  
//     // Try to detect house number in any street part
//     for (let part of streetParts) {
//       const houseAndStreetMatch = part.match(/^(\d+)\s+(.*)$/);
//       if (houseAndStreetMatch) {
//         houseNumber = houseAndStreetMatch[1];
//         streetName = houseAndStreetMatch[2];
//         break;
//       }
//     }
  
//     // If no house number match found, assume last part of street is just name
//     if (!streetName && streetParts.length > 0) {
//       streetName = streetParts[streetParts.length - 1];
//     }

//     // If still empty (e.g., only city-state-country provided), set empty string
//     if (!streetName) {
//       streetName = "";
//     }
  
//     // Safe parseInt with fallback to null for house_number
//     const parsedHouseNumber = houseNumber ? parseInt(houseNumber, 10) : null;
    
//     const addressComponents = {
//       house_number: !isNaN(parsedHouseNumber) ? parsedHouseNumber : null,
//       street_name: streetName,
//       city: city,
//       state: state,
//       zip_code: zipCode,
//       country: country
//     };
  
//     return addressComponents;
// };

helpers.extractAddressComponents = function (components, config = {}) {
  const get = (type, format = "long") => {
    const found = components.find((comp) => comp.types.includes(type));
    return found ? found[`${format}Text`] : "";
  };

  const postalCode = get("postal_code", config.postalCode || "long");
  const postalCodeSuffix = get(
    "postal_code_suffix",
    config.postalCodeSuffix || "long"
  );
  const zip_code = postalCodeSuffix
    ? `${postalCode}-${postalCodeSuffix}`
    : postalCode;

  const city =
    get("locality", config.city || "long") ||
    get("sublocality", config.city || "long");

  const state = get("administrative_area_level_1", config.state || "long");
  const country = get("country", config.country || "long");

  // ❌ Return false if required components are missing
  if (!city || !zip_code || !state || !country) {
    return false;
  }

  const addressComponents = {
    house_number:
      parseInt(get("street_number", config.streetNumber || "long")) || null,
    street_name: get("route", config.route || "long"),
    city,
    state,
    zip_code,
    country,
  };

  return addressComponents;
};

helpers.dataURItoBlob = function (dataURI) {
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

module.exports = helpers;
